export default "__VITE_ASSET__b167b4fc__"